/* eslint-disable @typescript-eslint/naming-convention */
import axios from "axios";
import { AntiForgery } from "./AntiForgery";
import { ContentDisposition } from "./ContentDisposition";
import { DefaultRequestFactory } from "./RequestFactory";
import { DefaultResponseHandler } from "./ResponseHandler";
const baseUrl = "./api";
const xsrf = {
    header: "X-XSRF-TOKEN",
    token: ""
};
const createDefaultConfig = () => {
    return {
        baseURL: baseUrl,
        headers: {
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "X-Requested-By": location.origin,
            "Content-Type": "application/json"
        },
        validateStatus: () => {
            return true;
        }
    };
};
class WebApi {
    static responseHandler = new DefaultResponseHandler();
    static requestFactory = new DefaultRequestFactory();
    static antiForgery = new AntiForgery();
    static createConfig = createDefaultConfig;
    static http = axios.create(createDefaultConfig());
    static configure(configure) {
        WebApi.createConfig = () => {
            let config = createDefaultConfig();
            configure(config);
            return config;
        };
        WebApi.http = axios.create(WebApi.createConfig());
        WebApi.antiForgery.setup(WebApi.http);
    }
    static resolveUrl(path) {
        const config = WebApi.createConfig();
        const baseUrl = config.baseURL;
        if (baseUrl) {
            return `${baseUrl}/${path}`;
        }
        return `./${path}`;
    }
    static async request(config) {
        config.method = config.method ?? "get";
        const response = await WebApi.http.request(config);
        return WebApi.responseHandler.handle(response, config);
    }
    static async requestBlob(config) {
        config.method = config.method ?? "post";
        const response = await WebApi.http.request({
            ...config,
            responseType: "blob"
        });
        return response;
    }
    static async download(path, params) {
        let config = WebApi.createConfig();
        config.method = "get";
        config.url = path;
        config.responseType = "blob";
        const response = await WebApi.http.request(config);
        const data = WebApi.responseHandler.handle(response, config);
        const content = ContentDisposition.parse(response.headers["content-disposition"]);
        return {
            type: content.type,
            params: content.parameters,
            data: data
        };
    }
    static async downloadByConfig(config) {
        config.responseType = "blob";
        const response = await WebApi.http.request(config);
        const data = WebApi.responseHandler.handle(response, config);
        const content = ContentDisposition.parse(response.headers["content-disposition"]);
        return {
            type: content.type,
            params: content.parameters,
            data: data
        };
    }
    static async getFileBlob(config) {
        config.responseType = "blob";
        const response = await WebApi.http.request(config);
        const data = WebApi.responseHandler.handle(response, config);
        return data;
    }
    static async getFileBlobAndFileName(config) {
        config.responseType = "blob";
        const response = await WebApi.http.request(config);
        const data = WebApi.responseHandler.handle(response, config);
        let fileName;
        // ���K�\���Ńw�b�_����t�@�C�������擾����
        const match = response.headers["content-disposition"].match(/filename\*=UTF-8''([^;]+)/);
        if (match) {
            fileName = decodeURIComponent(match[1]);
        }
        return { data, fileName };
    }
}
export { axios, WebApi };
